import { render, staticRenderFns } from "./PatternD.vue?vue&type=template&id=1855bdba&scoped=true&"
import script from "./PatternD.vue?vue&type=script&lang=js&"
export * from "./PatternD.vue?vue&type=script&lang=js&"
import style0 from "./PatternD.vue?vue&type=style&index=0&id=1855bdba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1855bdba",
  null
  
)

export default component.exports